import Model from "../../classes/model/Model";
import User from "./User";
import qs from "qs";
import Client from "./Client";

/**
 * @property {int} id
 * @property {int} old_id
 * @property {int} outer_id
 * @property {int} client_id
 * @property {string} phone
 * @property {string} content
 * @property {int} status
 * @property {string} phone
 * @property {string} comment
 *
 * @property {int} created_by
 * @property {int} updated_by
 * @property {int} created_at
 * @property {int} updated_at
 *
 * @property {Client} client
 * @property {User} creator
 * @property {User} updater
 */
export default class Sms extends Model {

    relations() {
        return {
            client: {class: Client, many: false},
            creator: {class: User, many: false},
            updater: {class: User, many: false},
        };
    }

    static getList(filter = {}, page = 1, sort = undefined, perPage = 25,  extraFields = []) {

        return Sms.getAxios().get(Sms.getUrl('sms/list'), {
            params: {
                page: page,
                'per-page': perPage,
                filter: filter,
                sort: sort,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
            paramsSerializer: params => qs.stringify(params),
        }).then((response) => {
            let data = [];
            for (let bid of response.data) {
                data.push(new Sms(bid));
            }
            return {data, headers: response.headers};
        });
    }

    static getById(id, extraFields = []) {

        return this.getAxios().get(this.getUrl('sms/get-by-id'), {
            params: {
                id: id,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
        }).then(({data}) => {
            return new Sms(data);
        });
    }

}
